import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { ScholarshipCategoryDto, ScholarshipTypeDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-scholarship-type-view',
  templateUrl: './scholarship-type-view.component.html',
  styleUrls: ['./scholarship-type-view.component.css'],
})
export class ScholarshipTypeViewComponent implements OnInit {
  @Input() scholarshipCategories: ScholarshipCategoryDto[];
  @Input() scholarshipTypes: ScholarshipTypeDto[];
  scholarshipTypeForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<ScholarshipTypeDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  selectedScholarshipCategory: any;
  filteredDelete: Array<any> = [];
  loading = true;
  filteredScholarshipType: Array<any> = [];
  status: boolean;
  selectedScholarshipCategoryId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.scholarshipTypeForm = this.fb.group({
      ScholarshipTypes: this.fb.array([]),
    });
  }

  // method to display countries
  setScholarshipType() {
    const control = this.scholarshipTypeForm.controls
      .ScholarshipTypes as FormArray;
    this.filteredScholarshipType.forEach((e) => {
      control.push(
        this.fb.group({
          ScholarshipTypeName: e.ScholarshipTypeName,
          ScholarshipCategoryId: e.ScholarshipCategoryId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.scholarshipTypeForm.controls
      .ScholarshipTypes as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectScholarshipType(event: string) {
    this.filteredScholarshipType = this.scholarshipTypes.filter(
      (s) => s.ScholarshipCategoryId === event
    );
    this.selectedScholarshipCategoryId = event;
    const control = this.scholarshipTypeForm.controls
      .ScholarshipTypes as FormArray;

    if (this.filteredScholarshipType.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setScholarshipType();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addScholarshipType() {
    const control = this.scholarshipTypeForm.controls
      .ScholarshipTypes as FormArray;
    control.insert(
      0,
      this.fb.group({
        ScholarshipTypeName: ['', Validators.required],
        ScholarshipCategoryId: this.selectedScholarshipCategoryId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteScholarshipType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.scholarshipTypeForm.controls
          .ScholarshipTypes as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.scholarshipTypes.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.scholarshipTypes[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    console.log(formValue);
    formValue.type = 'scholarshipType';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('scholarshipType');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
